import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import Slider, { Settings as SliderSettings } from 'react-slick'

import type { Paragraph, ParagraphComponent } from '../types'
import type { DrupalMedia } from '../../Media'

import Container from '../../Container'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { colors } from '../../../styles/variables'
import Media from '../../Media'

export interface CarouselParagraph extends Paragraph {
	relationships: {
		field_media_multiple: DrupalMedia[]
	}
}

const SlickSettings: SliderSettings = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1
}

const Carousel: ParagraphComponent<CarouselParagraph> = ({ className, paragraph }) => (
	<section id={`gallery-${paragraph.drupal_internal__id}`} className={className}>
		<Container>
			<Slider
				{...SlickSettings}
				css={{
					'.slick-arrow:before': {
						color: colors.brand
					}
				}}
			>
				{paragraph.relationships.field_media_multiple.map(media => (
					<div key={media.mid} className="item">
						<Media source={media} />
					</div>
				))}
			</Slider>
		</Container>
	</section>
)

export default styled(Carousel)`
	.item {
		display: flex;
		align-items: center;
	}

	.gatsby-image-wrapper {
		width: 100%;
	}
`

export const query = graphql`
	fragment CarouselParagraph on paragraph__carousel {
		drupal_internal__id
		relationships {
			field_media_multiple {
				__typename
				... on media__image {
					...MediaImage
				}
			}
		}
	}
`
